<template>
    <div :class="['rounded-lg bg-primary-100']">
        <div @click="expanded = !expanded" :class="[, 'flex items-center justify-between  cursor-pointer select-none duration-150 rounded-lg border py-2.5 px-4 bg-white']">
            <h3 class="text-xl font-light">Grades</h3>

            <button class="">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" fill="currentColor" viewBox="0 96 960 960" width="24">
                    <path v-if="expanded" class="" d="m296 711-56-56 240-240 240 240-56 56-184-184-184 184Z" />
                    <path v-else class="" d="M480 711 240 471l56-56 184 184 184-184 56 56-240 240Z" />
                </svg>
            </button>
        </div>
        <div v-show="expanded" class="p-2">
            <AisRefinementList :attribute="attribute" :limit="30">
                <template v-slot:default="{ items, refine }">
                    <div v-for="item in sortGrades(items)" :key="item.label" :class="['flex mr-2', nestCount(item.label) == 1 ? 'mt-2 mb-1' : '', nestCount(item.label) == 2 ? 'mt-2 mb-1' : '', nestCount(item.label) == 3 ? 'mt-2 mb-1' : '']" :style="{ marginLeft: `${nestCount(item.label)}rem` }">
                        <div class="flex space-x-2">
                            <input type="checkbox" class="rounded bg-transparent mt-[2px] checked:text-primary-500 focus:outline-primary-500" :id="item.label" :value="item.label" :checked="item.isRefined" @input="refine($event.target.value)" />
                            <span :class="['text-base', nestCount(item.label) > 1 ? 'text-sm' : '', 'leading-5']">
                                {{ getLeafItem(item.label) }} <span class="text-xs">({{ item.count }})</span>
                            </span>
                        </div>
                    </div>
                </template>
            </AisRefinementList>
        </div>
    </div>
</template>

<script>
import { AisRefinementList } from "vue-instantsearch/vue3/es";

import { getLeafItem, nestCount } from "../utils/NestedItemsUtils";

import { usePage } from "@inertiajs/vue3";

export default {
    components: {
        AisRefinementList,
    },
    data() {
        return {
            expanded: false,
        };
    },
    methods: {
        sortGrades(items) {
            // Custom sort order: PK, K, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, AP
            const gradeOrder = ["PK", "K", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "AP"];

            return [...items].sort((a, b) => {
                const aIndex = gradeOrder.indexOf(a.label);
                const bIndex = gradeOrder.indexOf(b.label);

                // If both grades are in the predefined order, sort by that order
                if (aIndex !== -1 && bIndex !== -1) {
                    return aIndex - bIndex;
                }

                // If only a is in the order, it comes first
                if (aIndex !== -1) return -1;

                // If only b is in the order, it comes first
                if (bIndex !== -1) return 1;

                // If neither is in the order, sort alphabetically
                return a.label.localeCompare(b.label);
            });
        },
    },
    mounted() {
        // console.log(this.regionsNamesMap)
    },
    computed: {
        attribute() {
            return `grades`;
        },
    },
    props: {},
    setup() {
        const tenantSlug = usePage().props.tenantSlug;

        return {
            getLeafItem,
            nestCount,
            tenantSlug,
        };
    },
};
</script>
